import RestService from './RestService';

export default class Admins extends RestService {
    constructor() {
        super('/admins');
    }
}
